"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Note = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var utils_1 = require("../../../utils/utils");
var Text_1 = require("../Typography/Text");
var StyledNote = (0, styled_components_1.default)("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-left: 3px solid ", ";\n  padding: 20px;\n  display: flex;\n  position: relative;\n  width: 100%;\n  box-sizing: border-box;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  border-radius: ", "px;\n  background: ", ";\n  .description {\n    margin: 0;\n    font-size: 14px;\n  }\n  .time {\n    margin: 0 0 0 20px;\n    font-size: 14px;\n  }\n"], ["\n  border-left: 3px solid ", ";\n  padding: 20px;\n  display: flex;\n  position: relative;\n  width: 100%;\n  box-sizing: border-box;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  border-radius: ", "px;\n  background: ", ";\n  .description {\n    margin: 0;\n    font-size: 14px;\n  }\n  .time {\n    margin: 0 0 0 20px;\n    font-size: 14px;\n  }\n"])), function (props) { return (props.color ? props.color : "#F2C94C"); }, function (props) { return props.theme.cardRadius; }, function (_a) {
    var theme = _a.theme;
    return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.dm__cardBackgroundColor, theme.cardBackgroundColor);
});
var Note = function (props) {
    var description = props.description, time = props.time, color = props.color, _a = props.className, className = _a === void 0 ? "" : _a;
    return ((0, jsx_runtime_1.jsxs)(StyledNote, __assign({ className: "wellms-component ".concat(className), color: color }, { children: [(0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ className: "description" }, { children: description })), (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ className: "time" }, { children: time }))] })));
};
exports.Note = Note;
var templateObject_1;
